import { generateBreadcrumbs } from "./BredcrumbLdjson";
import { AllPagesSEOData, PagejsonLd } from "./fetchdata";
import authors from "@/data/blogauthors.json"
import blogsData from "@/data/blogsdata.json"

type FAQSchemaProps = {
    faq: { question: string; answer: string }[];
};

const generateFaqSchema = ({ faq = [] }: FAQSchemaProps) => {
    if (!faq.length) return null;

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faq.map(({ question, answer }) => ({
            "@type": "Question",
            "name": question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": answer,
            },
        })),
    };

    return [faqSchema];
};

const formatDate = (date: string | Date) => {
    const formattedDate = new Date(date);
    if (isNaN(formattedDate.getTime())) {
        throw new Error("Invalid date format");
    }
    formattedDate.setUTCHours(18, 30, 0, 0); 
    return formattedDate.toISOString();
};


export function getSeoData(FullURL: string): any {
    const segments = FullURL.split('/').filter(Boolean);
    
    const lastSegment = segments[segments.length - 1] || "";
    
    const cleanURL = FullURL.replace(/\/$/, "");
    
    const siteURL = process.env.NEXT_PUBLIC_FRONTEND_URL;
    
    const breadcrumbs = generateBreadcrumbs(FullURL);
    
    let seoData: any = null;
    
    // const generalMatch = AllPagesSEOData.find(
    //     (page: any) => page.page_title?.toLowerCase().replace(/\s+/g, "-") === lastSegment
    // );

    const generalMatch = AllPagesSEOData.find(page =>
        page.page_title?.toLowerCase().replace(/\s+/g, "-") === (FullURL === "/" ? "home" : lastSegment)
    );

    if (generalMatch) {
        seoData = {
            seo_title: generalMatch.seo_title,
            seo_description: generalMatch.seo_description,
            seo_keyword: generalMatch.seo_keyword,
            og_image: siteURL + generalMatch.og_image,
            faq: generateFaqSchema({ faq: generalMatch.faq as any }),
            ld_json: PagejsonLd,
            breadcrumb: breadcrumbs,
            additionalldjson: generalMatch.json_ld,
            created_date: generalMatch.created_date,
            updated_date: generalMatch.updated_date,
        };
    } else if (FullURL.includes("author")) {
        const authormatch = authors.find((item: any) => item.slug === lastSegment);
        if (authormatch) {
            seoData = {
                seo_title: `${authormatch.displayName} - JBcodeapp Author Articles `,
                seo_description: authormatch.about_author,
                // seo_keyword: authormatch.keywords.join(", "),
                // faq: generateFaqSchema({ faqs: authormatch.faqs }),
                og_image: siteURL + authormatch.profile_image,
                ld_json: PagejsonLd,
                breadcrumb: breadcrumbs,
                // created_date: authormatch.created_date,
                // updated_date: authormatch.updated_date
            };
        }
    }  else if (FullURL.includes("/tags/")) {
        const tagmatch = lastSegment;
        const convertSlugToTitle = (slug: string) =>
            slug
                .split('-')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
        if (tagmatch) {
            seoData = {
                seo_title: `${convertSlugToTitle(lastSegment)} - JBcodeapp Articles `,
                // seo_description: tagmatch.about_author,
                // seo_keyword: tagmatch.keywords.join(", "),
                // faq: generateFaqSchema({ faqs: tagmatch.faqs }),
                // og_image: siteURL + tagmatch.profile_image,
                ld_json: PagejsonLd,
                breadcrumb: breadcrumbs,
                // created_date: tagmatch.created_date,
                // updated_date: tagmatch.updated_date
            };
        }
    } else if (cleanURL.includes("/blog/")) {
        // Read blog SEO synchronously from bundled data (data/blogsdata.json,
        // generated from mdx frontmatter). No runtime fetch — <SEO> renders in
        // the 'use client' layout and cannot be async.
        const match = (blogsData as any[]).find((item) => item.slug === lastSegment);

        if (match) {
            seoData = {
                seo_title: match.seo_title,
                seo_description: match.seo_description,
                seo_keyword: match.tags,
                og_image: siteURL + match.og_image,
                author: match.author,
                created_date: match.created_at,
                updated_date: match.published_at,
                ld_json: {
                    ...PagejsonLd,
                    datePublished: match.created_at,
                    dateModified: match.published_at,
                },
                breadcrumb: breadcrumbs,
                faq: generateFaqSchema({ faq: match.faqs as any || [] }),
                blog: true,
            };
        } else {
            // slug not found (e.g. a brand-new file not yet in blogsdata.json)
            const toTitle = (slug: string) =>
                slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
            seoData = {
                seo_title: `${toTitle(lastSegment)} - JBcodeapp Articles`,
                ld_json: PagejsonLd,
                breadcrumb: breadcrumbs,
                blog: true,
            };
        }
    }

    return seoData;
}
